export const REQUEST_BUYER_DETAILS = 'REQUEST_BUYER_DETAILS'
export const RECEIVE_BUYER_DETAILS = 'RECEIVE_BUYER_DETAILS'
export const STOP_RECEIVING_BUYER_DETAILS = 'STOP_RECEIVING_BUYER_DETAILS'
export const RECEIVED_PRODUCTS = 'RECEIVED_PRODUCTS'
export const RECEIVED_VENDORS = 'RECEIVED_VENDORS'
export const NO_PRODUCTS_FOUND = 'NO_PRODUCTS_FOUND'
export const NO_VENDORS_FOUND = 'NO_VENDORS_FOUND'

